<template>
  <component :is="colWrapper" v-bind="colProps">
    <validation-provider
      v-slot="validationContext"
      :name="validation_field_name || label"
      :rules="rules"
    >
      <b-form-group :label="label" :label-for="id">
        <b-input-group>
          <b-form-input
            :id="id"
            :value="value"
            :placeholder="placeholder"
            @input="$emit('input', $event)"
            :readonly="readOnly"
          />
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              @click="generateTimestamp"
              class="padding-0-1"
              style="padding: 0 1rem !important"
            >
              <feather-icon icon="ClockIcon" size="16" />
            </b-button>
          </b-input-group-append>
          <b-form-invalid-feedback :state="getValidationState(validationContext)">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
    </validation-provider>
  </component>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { watch, computed } from "@vue/composition-api";
import { format } from "date-fns";

export default {
  name: "BaseCurrentTimeInput",
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      default: "",
    },
    validation_field_name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: true,
    },
    cols: {
      type: [String, Number],
      default: null,
    },
    getValidationState: {
      type: Function,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const colWrapper = computed(() => (props.cols ? "b-col" : "div"));

    const colProps = computed(() => (props.cols ? { cols: props.cols } : {}));

    const generateTimestamp = () => {
      const now = new Date();
      const date = format(new Date(), "yyyy-MM-dd HH:mm:ss");

      emit("update:value", date);
    };

    return {
      colProps,
      colWrapper,
      generateTimestamp,
    };
  },
};
</script>

